import React, { Component } from "react";
import "./rule.scss";
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default class deliveryTime extends React.Component {

    render() {
        return ( 
            <div className = { isiOS ? 'IOSBulletprivacyHome BulletprivacyHome' : 'BulletprivacyHome' }>
                <div className = "Bulletprivacy earnestMoney" >
                    <h2 > 延长发货时间说明 </h2>
                    <span className="earnestRed">1、 卖家无法单方面延长发货时间，如需延长发货时间必须联系买家，双方协商一致后由买家操作延长发货时间。</span>< br/>
                    <span className="earnestRed">2、 延长发货时间最长1个月,双方协商一致可多次申请。</span>< br/>
                    <span className="earnestRed">3、 距离最晚发货时间小于两小时的，买家不可操作延长发货时间，如仍需修改最晚发货时间，请在双方协商一致后，由买家主动联系邮宝官方客服协助处理，联系电话：400-878-8498。</span><br/>
                </div>  
            </div>
        );
    }
}